import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

import { Order } from '~hooks/useOrders/models';
import { Project } from '~hooks/useProjects/models';
import { useStores } from '~store';

interface ChildCompanyBadgeProps {
  entity: Order | Project;
  sx?: SxProps<Theme>;
}

export default function ChildCompanyBadge({ entity, sx }: ChildCompanyBadgeProps) {
  const { userStore } = useStores();

  const { userCompanies } = userStore;
  const entityAccountCompanyId = entity.account?.accountBasicCompanyId;
  const isChildCompanyEntity = userCompanies.find((company) => {
    return company.id === entityAccountCompanyId;
  });

  if (userCompanies.length > 1) {
    const companyName = isChildCompanyEntity
      ? entity.company?.legalName
      : userStore.currentCompanies[0].legalName;

    return (
      <Box
        sx={[
          {
            alignItems: 'center',
            display: 'flex',
            gap: 0.5,
            maxWidth: '120px',
            mt: 0.25,
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <Tooltip title={companyName ?? ''}>
          <Chip
            label={companyName}
            size="small"
            sx={(theme) => ({
              bgcolor: theme.brandV2.colors.treadGray8,
              border: `1px solid ${theme.brandV2.colors.treadGray7}`,
              borderRadius: '4px',
              color: theme.brandV2.colors.treadBlack,
              fontSize: '12px',
              fontWeight: 600,
            })}
          />
        </Tooltip>
      </Box>
    );
  }

  return null;
}
